import styled from "styled-components";

export const MusicHallPaymentFormStyled = styled.div`
  border-radius: 8px;
  padding: 20px;
  background-color: ${({ theme }) => theme.COLORS.WHITE_1};
  max-width: 400px;
  width: 100%;
  .f_tile {
    margin-bottom: 20px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
  }
  .input_wrap {
    margin-bottom: 16px;
    .note {
      margin-top: 4px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
  }

  .action_layout {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .btn_action_wrap {
      max-width: 120px;
      width: 100%;
    }
  }
`;
